module.exports = __webpack_public_path__ + "img/case9.aefc61c6.svg";